// extracted by mini-css-extract-plugin
export default {"innerWrapper":"et-z","tooltipWrapper":"ft-z","icon":"gt-z","tooltip":"ht-z","content":"it-z"};